import { z } from "zod";
import { SITE_DOCUMENT_KINDS, SITE_DOCUMENT_MAX_BYTES } from "./types.js";

export const listSiteDocumentsInput = z.object({
  confirmationId: z.string().optional(),
  projectId: z.string().uuid(),
});
export type ListSiteDocumentsInput = z.infer<typeof listSiteDocumentsInput>;

export const recordSiteDocumentInput = z.object({
  confirmationId: z.string().optional(),
  projectId: z.string().uuid(),
  /**
   * Produit par l'écran au moment du dépôt. Contraint ici pour la même raison
   * que le chemin d'une photo : ce qui arrive d'un client n'est pas une donnée
   * de confiance, même quand c'est notre propre code qui l'a formé.
   */
  storagePath: z
    .string()
    .trim()
    .max(512)
    .regex(/^[0-9a-f-]{36}\/[0-9a-f-]{36}\/[0-9a-f-]{36}-[A-Za-z0-9-]+(\.[a-z0-9]{1,5})?$/, "Chemin de document invalide"),
  fileName: z.string().trim().min(1).max(200),
  mimeType: z.string().trim().min(1).max(120),
  sizeBytes: z.number().int().positive().max(SITE_DOCUMENT_MAX_BYTES),
  kind: z.enum(SITE_DOCUMENT_KINDS).default("autre"),
});
export type RecordSiteDocumentInput = z.infer<typeof recordSiteDocumentInput>;

export const shareSiteDocumentInput = z.object({
  confirmationId: z.string().optional(),
  documentId: z.string().uuid(),
  shared: z.boolean(),
});
export type ShareSiteDocumentInput = z.infer<typeof shareSiteDocumentInput>;

export const removeSiteDocumentInput = z.object({
  confirmationId: z.string().optional(),
  documentId: z.string().uuid(),
});
export type RemoveSiteDocumentInput = z.infer<typeof removeSiteDocumentInput>;
